import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import withState from 'recompose/withState';
import lifecycle from 'recompose/lifecycle';
import withHandlers from 'recompose/withHandlers';
import withQueryParams from '../../hocs/withQueryParams';
import { withFormik } from 'formik';
import { replaceCanvasText } from '../Canvas/helpers';
import { withModel } from '../../data-providers/model';
import { getProductBySlug } from 'src/common/config/product';
import { getProductsFromSelectedAddons, updateComponents } from './helpers';
import { localiseUrl } from 'src/common/utils/format-localised-url';
import { trackSaveAddonChanges } from '../../../analytics/category/cart';
import qs from 'qs';
import get from 'lodash/get';
import { trackAddOnsPageVisited } from '../../../analytics/category/product';

export const withAddOns = compose(
  withModel,
  withProps(props => ({
    items: get(props, 'model.productAddons.pages', [])
  }))
);

const parseAddonPage = (value, defaultValue) => {
  return parseInt(value, 10) || defaultValue;
};

export const withActivePage = compose(
  withQueryParams,
  withState('page', 'updatePage', props => parseAddonPage(props.queryParams.addonPage, 1)),
  withState('activePage', 'updateActivePage', props => props.items[Math.max(props.page - 1, 0)] || null),
  withState('isFirstPage', 'updateIsFirstPage', props => props.page === 1),
  withHandlers({
    goToPage: props => addonPage => {
      addonPage = parseAddonPage(addonPage, 1);
      const nextAddonIndex = Math.max(addonPage - 1, 0);
      const nextActivePage = props.items[nextAddonIndex];
      props.updatePage(addonPage);
      props.updateQueryParams({ addonPage });
      props.updateActivePage(nextActivePage);
      props.updateIsFirstPage(addonPage === 1);
      trackAddOnsPageVisited(addonPage);
      if (window) {
        window.scrollTo(0, 0);
      }
    }
  })
);

export const withAddonForm = compose(
  withModel,
  withFormik({
    mapPropsToValues: props => ({
      components: props.queryParams.components || []
    }),
    handleSubmit: (values, { props, ...formikProps }) => {
      const addonPage = props.page;
      const isLastPage = addonPage >= props.items.length;
      const cartItemId = props.match.params.itemId;
      const components = values.components;

      props.updateQueryParams({ components });
      if (!isLastPage && !cartItemId) {
        formikProps.setSubmitting(false);
        props.goToPage(addonPage + 1);
      } else {
        const items = getProductsFromSelectedAddons(props);
        const countryModel = props.model.countryModel;
        if (cartItemId) {
          const slug = props.match.params.productSlug;
          trackSaveAddonChanges(getProductBySlug(slug).sku);
          props.cart
            .edit(cartItemId)
            .then(() => (window.location = localiseUrl(countryModel, '/cart')));
        } else {
          props.cart.add(items);
        }
      }
    }
  }),
  withHandlers({
    updateComponents: props => item => () => {
      const components = updateComponents(props.values.components, item);
      props.updateProductCustomisation({ components });
      props.setFieldValue('components', components);
    }
  })
);

export const withAddonLifecycle = lifecycle({
  componentDidMount() {
    const props = this.props;
    const customisation = props.queryParams;
    trackAddOnsPageVisited(customisation.addonPage);
    props.updateProductCustomisation(customisation);
    props.history.listen((location, method) => {
      const query = qs.parse(location.search, { ignoreQueryPrefix: true });
      if (method === 'POP') {
        const page = parseAddonPage(query.addonPage, 1);
        props.goToPage(page);
      }
    });

    if (props.match.params.itemId) {
      props.flashMessage(replaceCanvasText(props.activePage.primary.editingBanner, props));
    }
  }
});



// WEBPACK FOOTER //
// ./src/client/js/view/components/AddOns/hocs.js